import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import {
  activateAcceptedTracking,
  disableAnalytics,
  disableMetaPixel,
  setTrackingSettings,
  trackMetaPageView,
  trackingConsentEvent,
} from "@/lib/analytics";
import { disableGtm } from "@/lib/gtm";

export const AnalyticsTracker = () => {
  const location = useLocation();
  const isAdminPath = location.pathname.startsWith("/admin");

  useEffect(() => {
    let active = true;
    const loadAnalytics = async () => {
      try {
        const { data } = await api.get("/analytics/config");
        if (!active) {
          return;
        }
        setTrackingSettings({
          measurementId: data.measurement_id,
          metaPixelId: data.meta_pixel_id,
        });
        if (!isAdminPath) {
          activateAcceptedTracking();
          trackMetaPageView();
        }
      } catch {
        // Analytics is optional. A failed config request must not affect storefront use.
      }
    };
    loadAnalytics();
    return () => {
      active = false;
    };
  }, [isAdminPath]);

  useEffect(() => {
    const syncConsentTracking = () => {
      if (isAdminPath) {
        return;
      }
      activateAcceptedTracking();
      trackMetaPageView();
    };
    window.addEventListener(trackingConsentEvent(), syncConsentTracking);
    return () => window.removeEventListener(trackingConsentEvent(), syncConsentTracking);
  }, [isAdminPath]);

  useEffect(() => {
    if (isAdminPath) {
      disableAnalytics();
      disableMetaPixel();
      disableGtm();
      return;
    }
    activateAcceptedTracking();
    trackMetaPageView();
  }, [
    isAdminPath,
    location.pathname,
    location.search,
    location.hash,
  ]);

  return null;
};